<template>
  <div id="sidebar-menu">
    <!-- {{layoutobject}}	
          fdsfdsf{{[layoutobject.split(' ').includes('horizontal-wrapper')]}} -->
    <ul class="sidebar-links custom-scrollbar" id="myDIV"
      :style="[ (String(layoutobject || '').split(' ').includes('horizontal-wrapper')) ? (layout.settings.layout_type == 'rtl' ? { '  -right': margin + 'px' } : { 'margin-left': margin + 'px' }) : { margin: '0px' } ]">
      <li class="back-btn">
        <router-link to="/">
          <img class="img-fluid" src="../../assets/images/logo/logo-icon.png" alt="" /></router-link>
        <div class="mobile-back text-end">
          <span>Back</span><vue-feather type="chevron-right" size="16" class="ps-2"></vue-feather>
        </div>
      </li>

      <!-- <li class="pin-title sidebar-main-title " :class="showPinTitle ? 'show' : ''">
      <li class="sidebar-main-title">
        <div>
          <h6 class="lan-1">Administrador</h6>
        </div>
      </li> -->

      <!-- Insert de parte dinámica-->
      <li v-for="(menuItem, index) in menuItems" :key="index" class="sidebar-list"
        :class="[{ ' sidebar-main-title': menuItem.type == 'headtitle' }, menuItem.showPin ? 'pined' : '']">

        <!-- Head Title -->
        <div v-if="menuItem.type == 'headtitle'">
          <h6 class="lan-1">{{ (menuItem.headTitle1) }}</h6>
        </div>

        <vue-feather v-if="menuItem.type != 'headtitle'" type="bookmark" size="14" class="pin-icon"
                    @click="togglePinnedName({ item: menuItem })"></vue-feather>
        
        <label :class="'badge badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{ (menuItem.badgeValue)
        }}</label>

        
        <a href="javascript:void(0)" class="sidebar-link sidebar-title" :class="{ 'active': menuItem.active }"
          v-if="menuItem.type == 'sub'" @click="setNavActive(menuItem, index)">

          <vue-feather v-if="menuItem.icon" :type="menuItem.icon" class="me-2"></vue-feather>
          <span class="lan-3">
            {{ menuItem.title }}
          </span>
          <div class="according-menu" v-if="menuItem.children">
            <vue-feather type="chevron-right" size="16" class="pull-right"></vue-feather>
          </div>
        </a>
        
        <router-link :to="menuItem.path" class="sidebar-link sidebar-title" v-if="menuItem.type == 'link'"
          :class="{ 'active': menuItem.active }" v-on:click="hidesecondmenu()" @click="setNavActive(menuItem, index)">

          <vue-feather v-if="menuItem.icon" :type="menuItem.icon" class="me-2"></vue-feather>
          <span>
            {{ menuItem.title }}
          </span>
          <vue-feather type="chevron-right" size="16" class="pull-right" v-if="menuItem.children"></vue-feather>
        </router-link>

        <a :href="menuItem.path" class="sidebar-link sidebar-title" v-if="menuItem.type == 'extLink'"
          @click="setNavActive(menuItem, index)">

          <vue-feather v-if="menuItem.icon" :type="menuItem.icon" class="me-2"></vue-feather>
          <span>
            {{ (menuItem.title) }}
          </span>
          <vue-feather type="chevron-right" size="16" class="pull-right" v-if="menuItem.children"></vue-feather>
        </a>

        <a :href="menuItem.path" target="_blank" class="sidebar-link sidebar-title" v-if="menuItem.type == 'extTabLink'"
          @click="setNavActive(menuItem, index)">

          <vue-feather v-if="menuItem.icon" :type="menuItem.icon" class="me-2"></vue-feather>
          <span>
            {{ (menuItem.title) }}
          </span>
          <vue-feather type="chevron-right" size="16" class="pull-right" v-if="menuItem.children"></vue-feather>
        </a>

        <ul class="sidebar-submenu" v-if="menuItem.children" :class="{ 'menu-open': menuItem.active }"
          :style="{ display: menuItem.active ? '' : 'none' }">

          <li v-for="(childrenItem, index) in menuItem.children" :key="index">

            <a class="lan-4" :class="{ 'active': childrenItem.active }" href="javascript:void(0)"
              v-if="childrenItem.type == 'sub'" @click="setNavActive(childrenItem, index)">
              {{ (childrenItem.title) }}
              <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                childrenItem.badgeValue }}</label>
              <vue-feather :type="childrenItem.active ? 'chevron-down' : 'chevron-right'" size="16" class="pull-right mt-1"
                v-if="childrenItem.children"></vue-feather>
            </a>

            <router-link class="lan-4" :class="{ 'active': childrenItem.active }" :to="childrenItem.path"
              v-if="childrenItem.type == 'link'" @click="setNavActive(childrenItem, index)"
              v-on:click="hidesecondmenu()">
              {{ (childrenItem.title) }}
              <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                (childrenItem.badgeValue) }}</label>
              <vue-feather type="chevron-right" size="16" class="pull-right mt-1" v-if="childrenItem.children"></vue-feather>
            </router-link>

            <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'" class="submenu-title">
              {{ (childrenItem.title) }}
              <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                (childrenItem.badgeValue) }}</label>
              <vue-feather type="chevron-right" size="16" class="pull-right mt-1" v-if="childrenItem.children"></vue-feather>
            </a>

            <a class="submenu-title" :href="childrenItem.path" target="_blank" v-if="childrenItem.type == 'extTabLink'">
              {{ (childrenItem.title) }}
              <label :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                (childrenItem.badgeValue) }}</label>
              <vue-feather type="chevron-right" size="16" class="pull-right mt-1" v-if="childrenItem.children"></vue-feather>
            </a>

            <ul class="nav-sub-childmenu submenu-content" v-if="childrenItem.children"
              :class="{ 'opensubchild': childrenItem.active }">
              <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">

                <router-link :class="{ 'active': childrenSubItem.active }" :to="childrenSubItem.path"
                  v-if="childrenSubItem.type == 'link'" v-on:click="hidesecondmenu()"
                  @click="setNavActive(childrenSubItem, index)">
                  {{ (childrenSubItem.title) }}
                  <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                    v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                  <vue-feather type="chevron-right" size="16" class="pull-right" v-if="childrenSubItem.children"></vue-feather>
                </router-link>

                <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                  {{ (childrenSubItem.title) }}
                  <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                    v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                  <vue-feather type="chevron-right" size="16" class="pull-right" v-if="childrenSubItem.children"></vue-feather>
                </router-link>

                <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                  {{ (childrenSubItem.title) }}
                  <label :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                    v-if="childrenSubItem.badgeType">{{ (childrenSubItem.badgeValue) }}</label>
                  <vue-feather type="chevron-right" size="16" class="pull-right" v-if="childrenSubItem.children"></vue-feather>
                </router-link>
              </li>
            </ul>
          </li>
        </ul> 

      </li>

    </ul>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useMenuStore } from '@/stores/menu';
import { useLayoutStore } from '@/stores/layout';
import { layoutClasses } from '../../constants/layout';

export default {
  name: 'Navmenu',
  data() {
    return {
      layoutobj: {},
      items: [],
      text: '',
      active: false,
    };
  },
  setup() {
    const menuStore = useMenuStore();
    const layoutStore = useLayoutStore();
    const { data: menuItems, activeoverlay, togglesidebar, width, height, margin, menuWidth, hideRightArrow, hideLeftArrow, hideRightArrowRTL, hideLeftArrowRTL } = storeToRefs(menuStore);
    const { layout, sidebarType } = storeToRefs(layoutStore);

    return {
      menuStore,
      layoutStore,
      menuItems,
      activeoverlay,
      togglesidebar,
      width,
      height,
      margin,
      menuWidth,
      hideRightArrow,
      hideLeftArrow,
      hideRightArrowRTL,
      hideLeftArrowRTL,
      layout,
      sidebarType,
    };
  },
  computed: {
    showPinTitle: {
      get() {
        let show = false;
        this.menuItems.every(item => {
          item.showPin && (show = true)
          return !show
        })
        return show
      }
    },
    layoutobject: {
      get: function () {
        return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
        return this.layoutobj;
      }
    }
  },
  watch: {
    width() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
      if (this.menuStore.esMovil) {
        const newlayout = JSON.parse(JSON.stringify(this.layoutobject).replace('horizontal-wrapper', 'compact-wrapper'));
        document.querySelector('.page-wrapper').className = 'page-wrapper ' + newlayout;
        this.menuStore.margin = 0;
      } else {
        document.querySelector('.page-wrapper').className = 'page-wrapper ' + this.layoutobject;
      }

      if ((window.innerWidth < 1199 && this.layout.settings.layout === 'Tokyo') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Moscow') || (window.innerWidth < 1199 && this.layout.settings.layout === 'Rome')) {
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      }
    }
  },
  created() {

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.menuStore.width < 991) {
      this.layout.settings.layout = 'Dubai';
      this.margin = 0;
    }
    setTimeout(() => {
      this.menuStore.menuWidth > window.innerWidth ?
        (this.menuStore.hideRightArrow = false, this.menuStore.hideLeftArrowRTL = false) :
        (this.menuStore.hideRightArrow = false, this.menuStore.hideLeftArrowRTL = true);
    }, 500);
    this.layoutobject = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
    this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[this.layout.settings.layout];
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    window.addEventListener('unload', this.HandleUnload)
    let LocalPins = JSON.parse(localStorage.getItem('pins') || '[]')
    LocalPins.forEach(pin => {
      let pinIndex = this.menuItems.findIndex(menu => menu.title == pin);
      pinIndex > -1 && (this.menuItems[pinIndex].showPin = true)
    })    
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.menuStore.setActiveRoute(items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.menuStore.setActiveRoute(subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.menuStore.setActiveRoute(subSubItems);
        });
      });
    });
  },
  methods: {
    HandleUnload() {
      let pinsArray = [];
      this.menuItems.forEach(item => {
        item.showPin && pinsArray.push(item.title);
      })
      localStorage.setItem('pins', JSON.stringify(pinsArray))
    },
    handleScroll() {
      if (window.scrollY > 400) {
        // guard layoutobject and compute last segment safely
        const parts = String(this.layoutobject || '').split(' ');
        const last = parts.pop();
        if (last === 'material-type' || last === 'advance-layout')
          document.querySelector('.sidebar-main').className = 'sidebar-main hovered';
      } else {
        if (document.getElementById('sidebar-main'))
          document.querySelector('.sidebar-main').className = 'sidebar-main';
      }
    },
    togglePinnedName({ item }) {
      item.showPin = !item.showPin
      // this.active = !this.active
      if (this.menuItems.length > 0) {
        this.menuItems = 'show'
      } else {
        this.menuItems = ''
      }
    },
    setNavActive(item) {
      this.menuStore.setNavActive(item);
      if (String(this.layoutobject || '').split(' ').includes('compact-sidebar') && !this.menuStore.esMovil) {
        if (this.menuItems.some(menuItem => menuItem.active === true)) {
          this.menuStore.activeoverlay = true;
        } else {
          this.menuStore.activeoverlay = false;
        }
      }
    },
    setNavActiveh(item) {
      if (String(this.layoutobject || '').split(' ').includes('horizontal-wrapper')) {
        this.menuStore.setNavActive(item);
        if (String(this.layoutobject || '').split(' ').includes('compact-sidebar') && !this.menuStore.esMovil) {
          if (this.menuItems.some(menuItem => menuItem.active === true)) {
            this.menuStore.activeoverlay = true;
          } else {
            this.menuStore.activeoverlay = false;
          }
        }
      }
    },

    hidesecondmenu() {
      if (this.menuStore.esMovil) {
        this.menuStore.activeoverlay = false,
          this.menuStore.togglesidebar = false;
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      } else if (String(this.layoutobject || '').split(' ').includes('compact-sidebar')) {
        this.menuStore.activeoverlay = false,
          this.menuItems.filter(menuItem => {
            menuItem.active = false;
          });
      }
    },
    handleResize() {
      this.menuStore.width = window.innerWidth - 450;
    },
  }
};
</script>
